export const proposalContentTypeName = {
  ACCEPTANCE: "Proposal Acceptance",
  PROJECT_SUMMARY: "Proposal Stage Summary",
  STATEMENT_OF_WORK: "About Us",
  TERMS: "Terms and Conditions",
  TITLE_PAGE: "Cover Letter",
  INVOICE_DETAILS: "Invoice Details",
};

export const proposalContentTypeTooltip = {
  ACCEPTANCE: "Proposal Acceptance",
  PROJECT_SUMMARY: "Proposal Stage Summary",
  STATEMENT_OF_WORK: "About Us",
  TERMS: "Terms and Conditions",
  TITLE_PAGE: "Cover Letter",
  INVOICE_DETAILS: "Invoice Details",
};
